module.exports = __webpack_public_path__ + "img/flomsone.52db7499.jpg";